const infoRouter = [
  {
    path: '/',
    name: 'infoTwo',
    component: () => import('@/views/leaflets/infoTwo.vue'),
    meta: {
      title: '一片云',
      content: {
        keywords: '一片云-企业微信服务商，提供微信营销,私域运营全套工具，包括引流获客、客户跟进转化、社群运营等全方位工具，帮助企业构建高转化率的私域流量池。',
        description: '企业微信营销,社群运营、企业微信SCRM,私域流量运营,微信营销软件, 一片云'
      },
      hideFoot: true
    }
  }
]

export default infoRouter
